import { render, staticRenderFns } from "./InsuranceSubprogramPatients.vue?vue&type=template&id=63ac47fe&scoped=true"
import script from "./InsuranceSubprogramPatients.vue?vue&type=script&lang=js"
export * from "./InsuranceSubprogramPatients.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSubprogramPatients.vue?vue&type=style&index=0&id=63ac47fe&prod&lang=scss&scoped=true"
import style1 from "./InsuranceSubprogramPatients.vue?vue&type=style&index=1&id=63ac47fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac47fe",
  null
  
)

export default component.exports